/** The error notification each field component should show when save fails. */
export const errorNotification = {
    title: 'Failed to update attribute',
    text: 'An error occurred while updating the attribute value',
    time: 5000,
    type: 'error',
    icon: 'exclamation',
    status: 'danger',
};
